

















































































































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { DropifyFile } from '@/components/form'
import { DataTable } from '@/components/table'
import { Input, Select2 } from '@/components/general'

// services
import SignatureService from '@/services/config/SignatureService'

// Models
import { Paginator, ImageForm } from '@/models'
import { SignatureForm, Signature } from '@/models/config'

// constants
import { reportsWithSignatures } from '@/constants'

// utils
import { alerts, loading } from '@/utils'
import { get } from 'jquery'

const initForm: SignatureForm = {
  name: '',
  position: '',
  reports: '',
  is_active: true,
  image: null
}

export default defineComponent({
  name: 'SignaturesList',
  components: {
    PageHeader,
    DataTable,
    Input,
    Select2,
    DropifyFile
  },
  setup () {
    const loadingSignatures = ref(false)
    const showModal = ref(false)
    const actionFrom: Ref<'save'|'update'> = ref('save')
    const reports: Ref<number[]> = ref([])
    const file: Ref<ImageForm|null> = ref(null)
    const titleModal = computed(() => {
      if (actionFrom.value === 'save') {
        return 'Crear Firma'
      }
      return 'Editar firma'
    })
    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      count: 0,
      perPage: 10,
      total: 0
    })
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' },
        active: false
      },
      {
        text: 'Firmas',
        active: true
      }
    ]
    const headers = [
      {
        key: 'name',
        sortable: true,
        label: 'Nombre'
      },
      {
        key: 'position',
        sortable: true,
        label: 'Cargo'
      },
      {
        key: 'reports',
        sortable: false,
        label: 'Reportes'
      },
      {
        key: 'image',
        sortable: false,
        label: 'Imagen'
      },
      {
        key: 'actions',
        sortable: false,
        label: ''
      }
    ]
    const changeImage = ref(false)
    const idEdit = ref(0)
    const signature: Ref<SignatureForm> = ref({
      ...initForm
    })
    const signatures: Ref<Signature[]> = ref([])
    const getSignatures = async () => {
      loading('show')
      loadingSignatures.value = true
      const result = await SignatureService.getWithPagination(pagination.value.currentPage, pagination.value.perPage)
      const p = result.pagination
      pagination.value = {
        currentPage: p.currentPage,
        count: p.count,
        perPage: p.perPage,
        total: p.total
      }
      signatures.value = result.objects
      loading('hide')
      loadingSignatures.value = false
    }
    getSignatures()

    const reset = () => {
      signature.value = { ...initForm }
      reports.value = []
      idEdit.value = 0
      changeImage.value = false
      actionFrom.value = 'save'
      file.value = null
    }

    const addNew = () => {
      reset()
      showModal.value = true
    }

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getSignatures()
    }

    const changePerPage = (perPage: number) => {
      pagination.value.currentPage = 1
      pagination.value.perPage = perPage
      getSignatures()
    }

    const handleChangeFile = (f: ImageForm) => {
      if (f) {
        if (f.file_size < 2097152) {
          signature.value.image = {
            ...f
          }
          if (actionFrom.value === 'update') {
            changeImage.value = true
          }
          return
        }
      }
      signature.value.image = null
    }

    const formIsValid = () => {
      const { name, position } = signature.value
      if (!name || !position) {
        alerts.error('Debe agragar un nombre y posición!')
        return false
      }
      if (reports.value.length <= 0) {
        alerts.error('Debe agregar al menos un reporte donde se usara la firma.')
        return false
      }
      if (!file || !signature.value.image) {
        alerts.error('Debe agregar una imagen')
        return false
      }
      return true
    }

    const save = () => {
      if (formIsValid()) {
        signature.value.reports = reports.value.join(',')
        loading('show')
        const request = actionFrom.value === 'save' ? SignatureService.save(signature.value) : SignatureService.update(idEdit.value, changeImage.value, signature.value)

        request.then(() => {
          alerts.success()
          showModal.value = false
          reset()
          getSignatures()
        }).catch(error => {
          alerts.error(error)
        }).finally(() => {
          loading('hide')
        })
      }
    }

    const getReports = (reports: string) => {
      const reports_array = reports.split(',')
      let text = ''
      reports_array.forEach(r => {
        text += reportsWithSignatures.find(re => Number(re.value) === Number(r))?.text
        text += '<br/>'
      })
      return text
    }

    const deleteItem = async (item: Signature) => {
      const result = await alerts.confirm('Seguro que desea eliminar la firma seleccionada?')
      if (result) {
        loading('show')
        await SignatureService.delete(item.id)
        loading('hide')
        alerts.success()
        getSignatures()
      }
    }

    const editItem = (item: Signature) => {
      signature.value = {
        name: item.name,
        position: item.position,
        reports: item.reports,
        is_active: true,
        image: {
          dataURL: item.image_full_url,
          file_size: Number(item.image_size),
          file_type: item.image_type,
          filename: item.image_name
        }
      }
      reports.value = item.reports.split(',').map(r => Number(r))
      file.value = signature.value.image
      idEdit.value = item.id
      changeImage.value = false
      actionFrom.value = 'update'
      showModal.value = true
    }
    return {
      title: 'Firmas',
      breadcrumbs,
      headers,
      changePage,
      changePerPage,
      pagination,
      showModal,
      signature,
      titleModal,
      save,
      addNew,
      reset,
      reportsWithSignatures,
      reports,
      file,
      handleChangeFile,
      signatures,
      loadingSignatures,
      getReports,
      deleteItem,
      editItem
    }
  }
})
